
export const FETCH_ALL = "FETCH_ALL"
export const ADD_NEW = "ADD_NEW"
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"
export const GET_INVOICE = "GET_INVOICE"
export const FETCH_INVOICE_BY_USER = "FETCH_INVOICE_BY_USER"

export const ADD_NEW_INVENTORY = "ADD_NEW_INVENTORY"
export const UPDATE_INVENTORY = "UPDATE_INVENTORY"
export const DELETE_INVENTORY = "DELETE_INVENTORY"
export const GET_INVENTORY = "GET_INVENTORY"
export const FETCH_INVENTORY_BY_USER = "FETCH_INVENTORY_BY_USER"


export const ALL_CLIENTS = "ALL_CLIENTS"
export const UPDATE_CLIENT = "UPDATE_CLIENT"
export const DELETE_CLIENT = "DELETE_CLIENT"
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT"
export const FETCH_CLIENTS_BY_USER = 'FETCH_CLIENTS_BY_USER';

export const ALL_VENDORS = "ALL_VENDORS"
export const UPDATE_VENDOR = "UPDATE_VENDOR"
export const DELETE_VENDOR = "DELETE_VENDOR"
export const ADD_NEW_VENDOR = "ADD_NEW_VENDOR"
export const FETCH_VENDORS_BY_USER = 'FETCH_VENDORS_BY_USER';


export const ALL_METALS = "ALL_METALS"
export const UPDATE_METAL = "UPDATE_METAL"
export const DELETE_METAL = "DELETE_METAL"
export const ADD_NEW_METAL = "ADD_NEW_METAL"
export const FETCH_METALS_BY_USER = 'FETCH_METALS_BY_USER';

export const AUTH = "AUTH"
export const LOGOUT = "LOGOUT"
export const UPDATE_USER = "UPDATE_USER"
export const FETCH_USERS = "FETCH_USERS"
export const START_LOADING = "START_LOADING"
export const END_LOADING = "END_LOADING"
export const FETCH_CLIENT = "FETCH_CLIENT"
export const FETCH_METAL = "FETCH_METAL"
export const FETCH_VENDOR = "FETCH_VENDOR"

export const CREATE_PROFILE = 'CREATE_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const FETCH_PROFILES = 'FETCH_PROFILES';
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_BY_USER = 'FETCH_PROFILE_USER';
export const FETCH_PROFILES_BY_USER = 'FETCH_PROFILES_BY_USER';